type ApexChartsModule = typeof import('vue3-apexcharts')

let apexChartsPromise: Promise<ApexChartsModule['default']> | null = null
let prefetchScheduled = false

const shouldSkipPrefetch = () => {
  if (typeof window === 'undefined') return false
  if (typeof document === 'object' && document.visibilityState === 'hidden') {
    return true
  }

  const nav = navigator as Navigator & {
    connection?: {
      saveData?: boolean
      effectiveType?: string
    }
  }
  const connection = nav.connection
  if (!connection) return false

  if (connection.saveData) return true

  const effectiveType = String(connection.effectiveType || '').toLowerCase()
  return effectiveType === 'slow-2g' || effectiveType === '2g'
}

export const loadApexCharts = async () => {
  if (!apexChartsPromise) {
    apexChartsPromise = import('vue3-apexcharts').then((module) => {
      return module.default as ApexChartsModule['default']
    })
  }

  return apexChartsPromise
}

export const prefetchApexCharts = () => {
  if (apexChartsPromise || prefetchScheduled || shouldSkipPrefetch()) return

  prefetchScheduled = true
  const runPrefetch = () => {
    prefetchScheduled = false
    void loadApexCharts().catch(() => {
      // Silent prefetch failure: interactive load path still works.
    })
  }

  if (typeof window !== 'undefined') {
    const win = window as Window & {
      requestIdleCallback?: (
        callback: () => void,
        options?: { timeout: number }
      ) => number
    }
    const scheduleIdlePrefetch = () => {
      if (typeof win.requestIdleCallback === 'function') {
        win.requestIdleCallback(runPrefetch, { timeout: 2500 })
        return
      }
      setTimeout(runPrefetch, 0)
    }
    setTimeout(scheduleIdlePrefetch, 300)
    return
  }

  setTimeout(runPrefetch, 0)
}
